import store from '@/store';

export default {
    install(Vue, opts) {
        store.state.bearerToken = localStorage.getItem('accountant_bearer');
    }
}
